(function() {
    angular.module('tmx-app').controller('processInstancesCtrl', ['$state', '$mdDialog', 'ProcessInstancesService', '$mdSidenav','ToastService', 

        function ProcessInstancesCtrl($state, $mdDialog, ProcessInstancesService, $mdSidenav,ToastService) {
            var ProcessInstancesVM = this;


    ///////////////////FUNCTIONS////////////////////////
   
            ProcessInstancesVM.isFiltered=function(fieldName){
                var filtered = false;
                if(angular.isDefined(ProcessInstancesVM.filters)) {
                    ProcessInstancesVM.filters.filters.forEach(function(filter){
                        if(filter.field==fieldName)
                            filtered = true;
                    });
                }
                return filtered;
            }
    
            ProcessInstancesVM.getStatus = function(dataitem) {
                if(dataitem.Status=="Idled")
                    return 'Idled';
                else
                    return 'Finalized';
            };
            ProcessInstancesVM.reload = function() {
                ProcessInstancesVM.container.processInstanceGrid.dataSource.read();
            };
            ProcessInstancesVM.success=function(promise){
                if(promise.read==true) {
                    ProcessInstancesVM.container.processInstanceGrid.dataSource.transport.read(promise);
                }
                else {
                    ProcessInstancesVM.container.processInstanceGrid.dataSource.read(); 
                }
                ProcessInstancesVM.toggleSearch(ProcessInstancesVM.nav);
            };
            ProcessInstancesVM.onChildState = function() {
                if ($state.current.name.indexOf(".add") > 0 || $state.current.name.indexOf(".edit") > 0) return true;
            };
            ProcessInstancesVM.new = function() {
      // $state.go($state.current.name + ".add");
            };
            ProcessInstancesVM.clickEdit = function() {
      // $state.go($state.current.name + ".edit", {
      //   "Id": item.Id
      // });
            };
    
            ProcessInstancesVM.clickViewDesigner = function(item) {
                $mdDialog.show({
                    clickOutsideToClose: true,
                    template: '<md-dialog md-theme="default">' +
                    '  <md-dialog-content class="md-dialog-content">' +
                    '     <h1>Process ID '+item.Id+' Designer</h1>'+
                    '     <div id="wfdesigner" ></div>' +
                    '  </md-dialog-content>' +
                    '</md-dialog>',
                    controller: function DialogController($scope, $mdDialog, APP_CONSTANTS) {

                        var workflowdesignerDialogVM=this;
                        var wfdesigner = undefined;
                        var schemecode = 'LoanApplicationWF';
                        var processid = item.Id;
            // var processid = 'D2CA1861-7B5B-4F6B-BC10-B52D7C6C8691';
                        workflowdesignerDialogVM.url = APP_CONSTANTS.backend+ "loanapplication/workflow/Designer/";
                        workflowdesignerDialogVM.save = function () {
                            wfdesigner.schemecode = schemecode;
                            var err = wfdesigner.validate();
                            if (err != undefined && err.length > 0) {
                                alert(err);
                            }
                            else {
                    // wfdesigner.save();
                                err = wfdesigner.validate();
                                if (err != undefined && err.length > 0) {
                                    ToastService.showCustomToast("error",err);
                                }
                                else {
                                    wfdesigner.save(function () {
                                        ToastService.showCustomToast("success","Process Workflow Updated");
                                    });
                                }
                            }
                        };

                        workflowdesignerDialogVM.wfdesignerRedraw=function() {

                            var isreadonly = false;
                            if (processid != undefined && processid != '')
                                isreadonly = true;

                            // eslint-disable-next-line no-undef
                            wfdesigner = new WorkflowDesigner({
                    //name: 'simpledesigner',
                                name: 'LoanApplicationDesinger',
                                apiurl: workflowdesignerDialogVM.url,
                                renderTo: 'wfdesigner',
                                imagefolder: 'assets/images/WorkflowDesigner/',
                                readonly: isreadonly 
                    // graphwidth: $('#graphwidth').val(),
                    // graphheight: $('#graphheight').val()
                            });
                

                            var p = { schemecode: schemecode, processid: processid, readonly: isreadonly };
                            if (wfdesigner.exists(p))
                                wfdesigner.load(p);
                            else
                                wfdesigner.create();
                        }

                        workflowdesignerDialogVM.wfdesignerRedraw();


                        $scope.closeDialog = function() {
                            $mdDialog.hide();
                        }
                    }
                });

            };
            ProcessInstancesVM.Deactivate = function(item) {
                item.$deactivate(item.CustomerMasterId).then(function() {
                    ProcessInstancesVM.container.processInstanceGrid.dataSource.read();
                });
            };
            ProcessInstancesVM.Activate = function(item) {
                item.$activate(item.CustomerMasterId).then(function() {
                    ProcessInstancesVM.container.processInstanceGrid.dataSource.read();
                });
            };
            ProcessInstancesVM.isStatusActive = function(dataitem) {
       
                if (ProcessInstancesVM.getStatus(dataitem) == "Idled")
                    return true;
                else
                    return false;
            };
            ProcessInstancesVM.onClick = function(e, dataItem) {
                var element = $(e.currentTarget);
                var checked = element.is(':checked');
                var row = element.closest("tr");
                if (checked) {
                    row.addClass("k-state-selected");
                    ProcessInstancesVM.addToBulk(dataItem);
                }
                else {
                    row.removeClass("k-state-selected");
                    ProcessInstancesVM.removeFromBulk(dataItem);
                }
            };
   
            ProcessInstancesVM.toggleSearch = function() {
                if (ProcessInstancesVM.searchSideNavActive) {
        // ProcessInstancesVM.searchData = {};
                    ProcessInstancesVM.searchSideNavActive = false;
                }
                else
                    ProcessInstancesVM.searchSideNavActive = true;
                ProcessInstancesVM.toggle('SearchSideNav');
            }
            ProcessInstancesVM.toggleExport = function() {
                if (ProcessInstancesVM.exportSideNavActive)
                    ProcessInstancesVM.exportSideNavActive = false;
                else
                    ProcessInstancesVM.exportSideNavActive = true;
                ProcessInstancesVM.toggle('ExportSideNav');
            }
            ProcessInstancesVM.isOpen = function(navID) {
                return $mdSidenav(navID).isOpen();
            };
            ProcessInstancesVM.toggle = function(navID) {
                $mdSidenav(navID)
                    .toggle()
                    .then(function() {});
            };
            ProcessInstancesVM.search = function(navID) {
                let calls = [];
                for (var key in ProcessInstancesVM.searchData) {
                    if (ProcessInstancesVM.searchData.hasOwnProperty(key)) {
                        calls.push({
                            field: key,
                            operator: "contains",
                            value: ProcessInstancesVM.searchData[key]
                        });
                    }
                }
                ProcessInstancesVM.filt = {
                    filters: calls,
                    logic: "and"
                };
      // ProcessInstancesVM.searchObject.data.filter=ProcessInstancesVM.filt;
                ProcessInstancesVM.o.data.filter = ProcessInstancesVM.filt;
      // ProcessInstancesService.getByParams(ProcessInstancesVM.searchObject,true).then(function(response){
      //               ProcessInstancesVM.container.processInstanceGrid.dataSource.data(response.data);
      //               // ProcessInstancesVM.container.processInstanceGrid.dataSource.read();
      //               // o.success(response)
      //             });
                ProcessInstancesVM.container.processInstanceGrid.dataSource.transport.read(ProcessInstancesVM.o);
      // ProcessInstancesVM.searchData = {};
                ProcessInstancesVM.toggle(navID);
            };
            ProcessInstancesVM.clear = function(navID) {
      // ProcessInstancesVM.searchData = {};
                ProcessInstancesVM.toggle(navID);
            };
            ProcessInstancesVM.clearSideNav = function() {
                ProcessInstancesVM.searchData = {};
            };
    ////////////////////////////////////////////////////

    
    //////////////////////CODE//////////////////////////
            ProcessInstancesVM.query = "ProcessInstance"
            ProcessInstancesVM.ProcessInstancesService = ProcessInstancesService;
            ProcessInstancesVM.cols = ProcessInstancesService.gridColumn;
            ProcessInstancesVM.nav = "SearchSideNav";
            ProcessInstancesVM.schema = ProcessInstancesService.schema;
    // ProcessInstancesVM.Devices = resolvedData.Devices.data;
            ProcessInstancesVM.date = new Date().toJSON();
            ProcessInstancesVM.gridData = new kendo.data.ObservableArray([]);
            ProcessInstancesVM.cloneColumn = angular.copy(ProcessInstancesService.gridColumn);
            ProcessInstancesVM.clone = 0;
            ProcessInstancesVM.dataObj = {
                value: "empty"
            };
            ProcessInstancesVM.gridColumns = angular.copy(ProcessInstancesService.columns);
            ProcessInstancesVM.gridColumns[3].template = "{{ProcessInstancesCtrl.getStatus(dataItem)}}";
            ProcessInstancesVM.gridColumns.push({
                title: "",
                width: "5%",
                template: "<md-menu md-position-mode=\"target-right target\" flex='none' class='menu-list-item' ><md-button class='menu-list-item-grid'  ng-click='$mdOpenMenu()' ><md-icon class='menu-list-item material-icons'>more_vert</md-icon></md-button><md-menu-content width='2' ><md-menu-item><md-button  aria-label='del' class='tmxMin' ng-click='ProcessInstancesCtrl.clickViewDesigner(dataItem,$event)'> <md-icon class='md-accent material-icons menu-list-item'>developer_board</md-icon>View Designer</md-button></md-menu-item></md-menu-content></md-menu>"
            });
            ProcessInstancesVM.mainGridOptions = {
                dataSource: {
                    transport: {
                        read: function(o) {
                            ProcessInstancesVM.o = angular.copy(o);
                            ProcessInstancesVM.filters = ProcessInstancesVM.o.data.filter;
                            ProcessInstancesService.getByParams(o, true).then(function(response) {
                                o.success(response)
                            });
                        },
                        dataType: "json"
                    },
                    schema: {
                        data: "data",
                        total: "Total"
                    },
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
        // sort:  [{field: "EffectiveEndDate", dir: "desc"}/*,{field: "CreatedDate", dir: "desc"}*/],
                },
      // selectable: "multiple, row",
                pageable: {
                    refresh: true,
                    pageSizes: true,
                    pageSize: 10,
                    buttonCount: 5
                },
                pdf: {
                    allPages: true,
                    fileName: "ProcessInstances.pdf"
                },
                excel: {
                    allPages: true,
                    fileName: "ProcessInstances.xlsx"
                },
                sortable: true,
                scrollable: false,
      //rowTemplate: "<tr data-uid='#= uid #' ng-class=\"{'deleted-row': ProcessInstancesCtrl.isStatusActive(dataItem)}\"><td><input type='checkbox' class='checkbox' ng-click='ProcessInstancesCtrl.onClick($event,dataItem)' /> </td><td>#= CompanyCode # </td><td>#= CompanyName # </td><td>#= CompanyTypeLkp # </td><td><md-button ng-disabled='ProcessInstancesCtrl.isStatusActive(dataItem)' aria-label='del' class='tmxMin' ng-click='ProcessInstancesCtrl.clickDelete(dataItem)'> <md-icon md-svg-src='assets/images/garbage12.svg' /></md-button><md-button ng-disabled='ProcessInstancesCtrl.isStatusActive(dataItem)' aria-label='del' class='tmxMin' ng-click='ProcessInstancesCtrl.clickEdit(dataItem)'> <md-icon md-svg-src='assets/images/edit45.svg' /></md-button><tmx-duplicate disable='ProcessInstancesCtrl.isStatusActive(dataItem)' model='dataItem' schema='ProcessInstancesCtrl.schema' columns='ProcessInstancesCtrl.cloneColumn' on-submit='ProcessInstancesCtrl.reload()'> </tmx-duplicate></td></tr>",
                columns: ProcessInstancesVM.gridColumns
            };
            ProcessInstancesVM.bulk = [];
            ProcessInstancesVM.container = {};
            $state.data = {
                grid: ProcessInstancesVM.container
            };
            ProcessInstancesVM.searchSideNavActive = false;
            ProcessInstancesVM.exportSideNavActive = false;
            ProcessInstancesVM.filt = {};
    ////////////////////////////////////////////////////
        }]);
})();
